import { TEST, FETCH_SURVEY_DEFINITION, UPDATE_TRANSLATION_STATUS, TRANSLATION_LIST,
  UPDATE_SURVEY_WITH_TRANSLATIONS } from "./design-store-constants";

export function TestAction(data) {
    return {
        type: TEST,
        payload: {
            test: data
        }
    }
}
export function getSurveyDefinition(data) {
    return {
        type: FETCH_SURVEY_DEFINITION,
        payload: {
            surveyDefinitionData: data
        }
    }
}

export function displayTranlslationPage(data) {
    return {
        type: UPDATE_TRANSLATION_STATUS,
        payload: {
            showTranslationPage: data
        }
    }
}

export function fetchTransactionListByID(data) {
   
    return {
        type: TRANSLATION_LIST,
       payload: {
            translationList: data
        }
    }
}
export function updateSurveyWithTranslations(translations) {
    return {
        type: UPDATE_SURVEY_WITH_TRANSLATIONS,
        payload: {
            translations
        }
    }
}